import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when user change language.
 * @memberOf Playtech.API.events
 * @event LANGUAGE_CHANGED
 * @example Playtech.on('LANGUAGE_CHANGED', (lang) => {
 *     // ...
 * });
 */

export const EVENT_USER_CHANGE_LANGUAGE = 'LANGUAGE_CHANGED';

export const useOnLangChange = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((lang): void => {
        const event = new CustomEvent(EVENT_USER_CHANGE_LANGUAGE, { detail: [lang] });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('user:action:changeLanguage', handleEvent);

        return () => publicEventsAPIService.off('user:action:changeLanguage', handleEvent);
    }, [handleEvent]);
};
